export const PAGE_SIZE = 50;
export const DEFAULT_OFFSET = 0;
